export enum apkBridgeProperties {
  ANDROID_BRIDGE = 'androidBridge',
  IOS_BRIDGE = 'iOSBridge'
}
